module.exports = __webpack_public_path__ + "img/allCards.644d5978.svg";